import * as Blockly from 'blockly/core';
import { expr } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['math_random'] = function (block: Blockly.Block): [string, number] {
        const from = gen.valueToCode(block, 'FROM', 0) || '0';
        const to = gen.valueToCode(block, 'TO', 0) || '10';
        return expr(`(${from} + random(${to} - ${from} + 1))`);
    };
}
